import { isSafeUrl } from '@/utils/branding';

interface DocLink {
  anchor: string;
  label: { ru: string; en: string };
}

const DOC_LINKS: Record<string, DocLink> = {
  'controller.addModal': {
    anchor: 'add-controller',
    label: { ru: 'Подробнее о добавлении', en: 'More about adding' },
  },
  'controller.deleteModal': {
    anchor: 'disconnect-controller',
    label: { ru: 'Подробнее об отключении', en: 'More about disconnecting' },
  },
  'controller.homeAssistant': {
    anchor: 'home-assistant-service',
    label: {
      ru: 'Что нужно знать про Home Assistant',
      en: 'What to know about Home Assistant',
    },
  },
  'controller.diagnostics': {
    anchor: 'cloud-diagnostic',
    label: { ru: 'Подробнее о диагностике', en: 'More about diagnostics' },
  },
  'controller.metrics': {
    anchor: 'metrics',
    label: { ru: 'Подробнее о метриках', en: 'More about metrics' },
  },
  'controller.metricsInterval': {
    anchor: 'metrics-interval',
    label: {
      ru: 'Подробнее об интервале отправки',
      en: 'More about the reporting interval',
    },
  },
  'controller.servicesModal': {
    anchor: 'controller-services',
    label: { ru: 'Подробнее о сервисах', en: 'More about services' },
  },
  'controller.status': {
    anchor: 'controller-problem',
    label: { ru: 'Подробнее о статусе', en: 'More about the status' },
  },
  'controllers.moveModal': {
    anchor: 'controller_transfer',
    label: { ru: 'Подробнее о переносе', en: 'More about transfers' },
  },
  'organization.inviteModal': {
    anchor: 'invite-members',
    label: { ru: 'Подробнее о приглашениях', en: 'More about invitations' },
  },
  'organization.totpModal': {
    anchor: 'mandatory-two-factor',
    label: { ru: 'Подробнее об обязательной 2FA', en: 'More about mandatory 2FA' },
  },
  'page.controller': {
    anchor: 'controller-page',
    label: {
      ru: 'Подробнее о странице контроллера',
      en: 'More about the controller page',
    },
  },
  'page.controllers': {
    anchor: 'controllers-list',
    label: {
      ru: 'Подробнее о списке контроллеров',
      en: 'More about the controller list',
    },
  },
  'page.organizations': {
    anchor: 'organizations',
    label: { ru: 'Подробнее об организациях', en: 'More about organizations' },
  },
  'security.email': {
    anchor: 'password-and-email',
    label: {
      ru: 'Подробнее о смене почты и пароля',
      en: 'More about changing your email and password',
    },
  },
  'security.sessions': {
    anchor: 'sessions',
    label: { ru: 'Подробнее о сессиях', en: 'More about sessions' },
  },
  'security.totp': {
    anchor: 'two-factor',
    label: { ru: 'Подробнее о 2FA', en: 'More about 2FA' },
  },
};

export const getDocLink = (place: string, locale: string) => {
  const page = (import.meta.env.SERVICE_DOCS_PAGE_URL as string) ?? '';
  const link = DOC_LINKS[place];

  if (!link || !isSafeUrl(page)) {
    return undefined;
  }

  return {
    url: `${page}#${link.anchor}`,
    label: link.label[locale as keyof DocLink['label']] || link.label.en,
  };
};
